import React from "react";
import PropTypes from "prop-types";
import { Grid, Container, Typography } from "@material-ui/core";
import R from "ramda";

import PlaceholderTileGroup from "components/PlaceholderTileGroup";
import Placeholder from "components/Placeholder";
import StarringYouPresenter from "presenters/StarringYouPresenter";

import StarringYou from "./components/StarringYou";
import useStyles from "./useStyles";

const StarringYouCards = ({ items, loading, title, size }) => {
  const classes = useStyles();

  const isSmall = size === "small";
  const lg = isSmall ? 2 : 3;

  const renderTitle = () => {
    if (loading)
      return (
        <Typography variant="h2">
          <Placeholder variant="text" />
        </Typography>
      );
    if (title && items) return <Typography variant="h2">{title}</Typography>;
    return null;
  };

  const renderContent = () => {
    const count = isSmall ? 12 : 8;
    if (loading)
      return R.range(0, count).map((index) => (
        <Grid key={`StarringYouCards-placeholder-${index}`} item xs={6} sm={3} md={3} lg={lg}>
          <StarringYou loading />
        </Grid>
      ));

    return (
      <>
        {items &&
          items.map((item) => (
            <Grid key={`starring-you-cards-${size}-${item.id}`} item xs={6} sm={3} md={3} lg={lg}>
              <StarringYou lazy item={item} />
            </Grid>
          ))}
        <PlaceholderTileGroup
          cardsType="starringYou"
          allCardsCount={StarringYouPresenter.allCardsCount(items)}
          xs={6}
          sm={3}
          md={3}
          lg={lg}
        />
      </>
    );
  };

  return (
    <div className={classes.root}>
      <Container>
        {renderTitle()}
        <Grid container spacing={2} className={classes.grid}>
          {renderContent()}
        </Grid>
      </Container>
    </div>
  );
};

StarringYouCards.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      type: PropTypes.string,
      attributes: PropTypes.shape({}),
    }),
  ),
  loading: PropTypes.bool,
  title: PropTypes.string,
  size: PropTypes.oneOf(["small", "big"]),
};

StarringYouCards.defaultProps = {
  title: "Starring You Ecards",
  size: "big",
  loading: false,
};

export default StarringYouCards;
